<div class="card car tw-drop-shadow-md my-2" *ngIf="car">
  <div class="d-flex justify-content-between">
    <div>
      <div class="availability py-1 px-2">
        Available in {{car.availabilityInDays}} Days
      </div>
      <p class="tw-p-2"><span class="tw-text-grayMid">Make Year </span> <b>{{car.year}}</b></p>
    </div>
    <app-shortlist-button [carId]="car._id"></app-shortlist-button>
  </div>
  <app-image-carousel (click)="navigateTo()" [images]="car.images.carousel || []"></app-image-carousel>
  <div class="tw-p-2" (click)="navigateTo()">
    <div class="tw-flex tw-p-2 tw-justify-between tw-border-t tw-border-grayLight tw-mt-2">
      <div class="tw-flex tw-items-center">
        <img [src]="car.brand.icon" alt="" style="width: 20px;">
        &nbsp;&nbsp;
        <p class="tw-text-grayMid"><b>{{car.brand.name | uppercase}}</b></p>
      </div>
      <div class="d-flex justify-content-between">
        <span class="text-center" style="white-space: nowrap;">
          <fa-icon class="tw-p-1" [icon]="faGasPump"></fa-icon>
          {{car.variant.specifications?.fuelType | titlecase}}
        </span>&nbsp;
        <span class="text-center" style="white-space: nowrap;">
          <fa-icon class="tw-p-1" [icon]="faCog"></fa-icon>
          {{car.variant.specifications?.transmissionType | titlecase}}
        </span>&nbsp;
        <span class="text-center" style="white-space: nowrap;">
          <fa-icon class="tw-p-1" color="red" [icon]="faCar"></fa-icon>
          {{car.variant.specifications?.bodyType | titlecase}}
        </span>
      </div>
    </div>
    <p class="tw-py-1 tw-px-2 tw-text-base">
      <b>{{car.model.name | uppercase}} {{car.variant.name | uppercase}}</b>
    </p>
  </div>
  <div (click)="navigateTo()" class="card-footer tw-p-2">
    <div class="tw-pl-1">
      <app-pricing-view [discountedPrice]="discountedPrice || car.displayPrice.discountedPrice"
        [originalPrice]="originalPrice || car.displayPrice.originalPrice"></app-pricing-view>
    </div>
  </div>
</div>